<template>
    <base-modal
        classes="modal-xl"
        @close="$emit('close')"
    >
        <div
            slot="header"
            class="h3"
        >
            <template>
                Doublons potentiels
                {{ programme.nom }}
            </template>
        </div>

        <div slot="body">
            <div v-if="!loading">
                <table class="table">
                    <base-table-header :head="head" />
                    <tbody>
                        <tr style="background-color: #5578eb; color: white">
                            <td>
                                {{ programme.nom }}
                            </td>

                            <td>
                                {{ programme.adresse }}
                            </td>

                            <td>
                                {{ programme.ville }}
                            </td>

                            <td>
                                {{ programme.code_postal }}
                            </td>

                            <td colspan="3">
                                {{ programme.programme_type }}
                            </td>
                        </tr>
                        <tr
                            v-for="doublon in doublons"
                            :key="doublon.programme.id"
                        >
                            <td>
                                {{ doublon.programme.nom }}
                            </td>

                            <td>
                                {{ doublon.programme.adresse }}
                            </td>

                            <td>
                                {{ doublon.programme.ville }}
                            </td>

                            <td>
                                {{ doublon.programme.code_postal }}
                            </td>

                            <td>
                                {{ doublon.programme.programme_type }}
                            </td>

                            <td>
                                {{ Math.round(doublon.accuracy) }} %
                            </td>

                            <td class="text-center d-flex">
                                <div
                                    class="btn btn-primary btn-sm"
                                    title="Voir"
                                    @click.stop="goToProgramme(doublon.programme)"
                                >
                                    <i class="fa fa-glasses" />
                                </div>

                                <div
                                    class="btn btn-success btn-sm"
                                    title="Fusionner"
                                    @click.stop="merge(doublon)"
                                >
                                    <i class="fa fa-hands-helping" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div
                v-else
                key="loader"
                class="mt-1 pt-0 mb-0"
            >
                <BaseLoader />
            </div>
        </div>
    </base-modal>
</template>

<script>
    import BaseTableHeader from "../templates/BaseTableHeader"
    import BaseModal from "../templates/BaseModal"
    import BaseLoader from "../templates/BaseLoader"

    export default {
        name: "ProgrammeDoublonModal",

        components: { BaseTableHeader, BaseModal, BaseLoader },

        props: {
            programme: { type: Object, required: true },
            doublonToReload: { type: Number, default: null },
        },

        data: function () {
            return {
                doublons: {},
                loading: false,
                head: {
                    nom: 'Nom',
                    adresse: 'Adresse',
                    ville: 'Ville',
                    code_postal: 'Code Postal',
                    type: 'Type',
                    similarity: 'Similarité',
                },
            }
        },

        watch: {
            'doublonToReload' : function () {
                this.reload(this.doublonToReload)
            },
        },

        created: function () {
            this.fetchDoublons()
        },

        methods: {
            fetchDoublons: function () {
                this.loading = true
                axios.get('/api/programmes/doublons/' + this.programme.id).then(response =>  {
                    this.doublons = response.data
                    this.loading = false
                })
                    .catch(() => {
                        this.$notify('danger', 'Une erreur est survenue lors de la recherche des doublons.')
                        this.$emit('close')
                    })
            },

            goToProgramme: function (programme) {
                this.$emit('see-doublon', programme)
            },

            merge: function (doublon) {
                this.loading = true
                axios.post('/api/programmes/doublons/merge', {main_programme_id: this.programme.id, doublon_programme_id: doublon.programme.id })
                    .then((response) => {
                        this.loading = false
                        this.$notify('success', 'Le doublon a bien été fusionné')
                        this.$emit('reload')
                        this.$emit('close')
                    })
                    .catch(() => {
                        $this.$emit('danger', 'La fusion des doublons a échoué')
                    })
            },

            reload: function (doublonId) {
                axios.get('/api/programmes/'+doublonId).then((response) => {
                    let index = this.doublons.findIndex(element => element.programme.id === doublonId)
                    this.doublons[index].programme = response.data.data
                    this.doublonToReload = null
                }).catch(() => {
                    this.$notify('danger', 'Les informations n\'ont pas été rafraichies')
                })
            },
        },
    }
</script>

<style scoped>

</style>
